import { Flex, Box } from 'theme-ui'
import { Text } from 'components'
import { ChevronDownIcon } from 'components/Icon'
import { ChangeEvent } from 'react'
import { ListTypes } from 'pages/Dashboard'
export type SortBySelectProps = {
  disabled?: boolean
  activeList?: ListTypes | string
  onSelectChange: (value: string) => void
}

export function SortBySelect({
  disabled = false,
  activeList = 'student',
  onSelectChange,
}: SortBySelectProps) {
  function handleSelectChange(e: ChangeEvent<any>) {
    if (disabled) return
    onSelectChange(e.target.value)
  }
  const regularUserOptions = (
    <>
      <option value="instructionDate">Instruction date latest</option>
      <option value="forename">First name</option>
      <option value="surname">Last name</option>
    </>
  )
  const tmattOptions = (
    <>
      <option value="instructionDate">Enrollment date</option>
      <option value="expirationDate">Expiration date</option>
    </>
  )
  return (
    <Flex sx={{ userSelect: 'none' }}>
      <Text sx={{ fontWeight: 'heading', color: 'gray' }}>Sort by</Text>
      <Flex sx={{ pl: 2, position: 'relative' }}>
        <Box
          as="select"
          aria-label="sortby-select"
          sx={{
            pr: 5,
            position: 'relative',
            color: 'text',
            fontWeight: 'heading',
            appearance: 'none',
            border: 0,
            background: 'none',
            outline: 'none',
            zIndex: 2,
            transition: '0.4s ease-in-out',
            opacity: disabled ? 0.6 : 1,
            pointerEvents: disabled ? 'none' : 'auto',
          }}
          onChange={handleSelectChange}>
          {activeList === 'tmatt' || activeList === 'refresher'
            ? tmattOptions
            : regularUserOptions}
        </Box>
        <Box
          sx={{
            position: 'absolute',
            right: 0,
            top: '-2px',
            pointerEvents: 'none',
          }}>
          <ChevronDownIcon />
        </Box>
      </Flex>
    </Flex>
  )
}
